import { Injectable } from '@angular/core';
import { Company } from '../models/company.model';

@Injectable({
  providedIn: 'root'
})
export class FaviconService {

  private defaultFavicon = 'favicon.ico';

  setFromCompany(company: Company | null) {
    if (company?.favicon_url) {
      this.set(company.favicon_url);
    } else {
      this.reset();
    }
  }

  set(url: string) {
    this.updateLink(url);
  }

  reset() {
    this.updateLink(this.defaultFavicon);
  }

  private updateLink(href: string) {
    let link = document.querySelector('link[rel="icon"]') as HTMLLinkElement;

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.href = href;
  }
}
